import { type ObjectMode } from '@databases/types';
import { type Database } from '@databases/types/database';
import { getExistingDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants.ts';

export const getEmptyDatabase = (): Database<ObjectMode.EXISTING> => {
  return getExistingDatabase({ contentId: databasesToContentId['emptyDatabase'] });
};
